import { render, staticRenderFns } from "./GiftRegistrationModal.vue?vue&type=template&id=2d2ebefd&scoped=true&"
import script from "./GiftRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./GiftRegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ebefd",
  null
  
)

export default component.exports